import { parseEther, formatGwei, formatUnits } from "viem";
import Web3 from "web3";
import store from "@/store";
export default {
  //格式化地址，len表示除了中间省略的部份以外的长度
  fmt_addr: function (value, len) {
    if (!value) return;
    let sect_len = Math.floor(len / 2);
    let start = value.substr(0, sect_len);
    let end = value.substr(-sect_len + 1, sect_len);
    return start + "..." + end;
  },
  //科学计数转成字符串
  fmt_sc(num) {
    const str = num.toString();
    // 检查是否是科学计数法表示
    if (/e/i.test(str)) {
      return num.toFixed(18); // 保留18位精度
    }
    return str;
  },
  //千分位
  fmt_th(_num, decimalPlaces) {
    if(!_num) {
      return _num
    }
    let str = _num.toString();
    if (/e/i.test(str)) {
      str = _num.toFixed(18);
    }
    let [integerPart, decimalPart = ""] = str.split(".");
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (decimalPlaces != null) {
      decimalPart = decimalPart.slice(0, decimalPlaces);
    }
    return decimalPlaces != null ? `${formattedInteger}${decimalPart ? `.${decimalPart}` : ""}` : formattedInteger;
  },

  //保留小数后位数,后面0忽略
  fmt_toPre(num, decimalPlaces = 18) {
    if (!num) return 0;
    const factor = Math.pow(10, decimalPlaces);
    return Math.floor(num * factor) / factor;
  },
  //保留小数后位数,剩下直接舍去
  fmt_dp(number, decimalPlaces) {
    const factor = Math.pow(10, decimalPlaces);
    return Math.trunc(number * factor) / factor;
  },

  fmt_pre(num, leng = 2, isFormatted = true, isThousand = true) {
    const thousandsSeparator = (n) => {
      const strSplit = n.toString().split(".");
      const integer = strSplit[0].split("");
      integer.reverse();
      const decimal = strSplit[1];
      const newInteger = [];
      for (let i = 0; i < integer.length; i++) {
        if (i % 3 === 0 && i !== 0) {
          newInteger.push(",");
        }
        newInteger.push(integer[i]);
      }
      newInteger.reverse();
      let s = newInteger.join("");
      if (decimal) {
        s += `.${decimal}`;
      }
      return s;
    };
    const fomatFloat = (num, len) => {
      const reg = new RegExp(`^(.*\\..{${len}}).*$`);
      let _num = String(num).replace(reg, "$1");
      return Number(_num);
    };
    const toPrecision = (num, len) => {
      if (!num) return 0;

      let str = String(fomatFloat(num, len));
      if (!/^[0-9.]+$/g.test(str)) return "0";
      while (str.includes(".") && (str.endsWith(".") || str.endsWith("0"))) {
        str = str.slice(0, -1);
      }
      return str;
    };
    const tranNum = (num, len) => {
      let numArr = String(num).split(".");
      let decimal = [];
      let integer = thousandsSeparator(numArr[0]);
      if (numArr.length <= 1) {
        return integer;
      }
      const bool = numArr[1].split("").every((it, idx) => {
        if (it > 0) {
          return false;
        } else {
          decimal.push(it);
          return true;
        }
      });
      if (bool) {
        return integer;
      }
      if (decimal.length > len) {
        let x = toPrecision(`0.${numArr[1].slice(decimal.length)}`, len);
        let n = x.split(".");
        if (n.length > 1) {
          return `${integer}.0<sub>${decimal.length}</sub>${n[1].slice(0, 3)}`;
        } else {
          return `${integer}`;
        }
      } else {
        let x = toPrecision(`0.${numArr[1]}`, len);
        let n = x.split(".");
        if (n.length > 1) {
          return `${integer}.${n[1]}`;
        } else {
          return `${integer}`;
        }
      }
    };
    const formatNumber = (num, precision = 2) => {
      let map = [
        { suffix: "T", threshold: 1e12 },
        { suffix: "B", threshold: 1e9 },
        { suffix: "M", threshold: 1e6 },
      ];
      if (isThousand) {
        map.push({ suffix: "K", threshold: 1e3 }, { suffix: "", threshold: 1 });
      } else {
        map.push({ suffix: "", threshold: 1 });
      }

      const found = map.find((x) => Math.abs(num) >= x.threshold);
      if (!found || found.threshold === 1) {
        return tranNum(num, leng);
      } else {
        const formatted = fomatFloat(num / found.threshold, precision) + found.suffix;
        return formatted;
      }
    };

    if (!num) return 0;

    if (isFormatted) {
      return formatNumber(num);
    } else {
      return tranNum(num, leng);
    }
  },

  //倒计时
  fmt_cd(stamp) {
    let _stamp = parseInt(stamp);
    let units = [
      { name: "year", value: 60 * 60 * 24 * 365 },
      { name: "month", value: 60 * 60 * 24 * 30 },
      { name: "day", value: 60 * 60 * 24 },
      { name: "hour", value: 60 * 60 },
    ];
    let min = null;
    if (!store.wallet?.isMobile) {
      min = { name: "min", value: 60 };
    } else {
      min = { name: "minute", value: 60 };
    }

    units.push(min);

    // Calculate unit values
    for (let { name, value } of units) {
      if (_stamp >= value) {
        const count = Math.floor(_stamp / value);
        return `${count} ${name}${count > 1 ? "s" : ""}`;
      }
    }

    // If under 1 minute, display seconds
    const seconds = _stamp % 60;
    return `< 1 minute`;
  },
  fmt_float(num, len = 5) {
    const reg = new RegExp(`^(.*\\..{${len}}).*`);
    let _num = String(num).replace(reg, "$1");
    console.log("reg", _num);
    return Number(_num);
  },
  fmt_floatDec(_num, type = "unit", dec) {
    if (!_num) return _num;
    const num = String(_num);
    if (type === "unit") {
      return formatUnits(num, dec || _v.web3Wallet.dec);
    } else if (type === "wei") {
      return parseEther(num);
    } else if (type === "gwei") {
      return formatGwei(num);
    } else if (type === "bigInt") {
      const web3 = new Web3();
      return web3.utils.toBigInt(num);
    }
  },

  /**
   * 格式化时间
   * @param {*} time 时间戳 毫秒
   * @param {*} type zh 中国格式 us 美国格式
   * @returns
   */
  fmt_time(time = new Date().getTime(), type = "zh", isDate = true) {
    if (!isDate) {
      time = time * 1000;
    } else if (isNaN(time)) {
      time = new Date(time).getTime();
    }

    let currentTime = new Date(parseInt(time));
    let month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
    let day = ("0" + currentTime.getDate()).slice(-2);
    let hour = ("0" + currentTime.getHours()).slice(-2);
    let minutes = ("0" + currentTime.getMinutes()).slice(-2);
    let seconds = ("0" + currentTime.getSeconds()).slice(-2);
    if (type == "zh") {
      return currentTime.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds;
    } else if (type == "en") {
      let _month = currentTime.getMonth();
      let monthEn = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      return day + " " + monthEn[_month] + " " + currentTime.getFullYear() + " at " + hour + " : " + minutes;
    } else if (type == "en-s") {
      return day + "-" + month + "-" + currentTime.getFullYear() + " " + hour + ":" + minutes + ":" + seconds;
    } else if (type === "en-ss") {
      let _month = currentTime.getMonth();
      let monthEn = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      return monthEn[_month] + " " + day;
    }
    // 2022-06-30 21:20:10.000
    // 2022-07-01 18:20:35.000
  },

  fmt_unique(arr, uniId) {
    const res = new Map();
    return arr.filter((item) => !res.has(item[uniId]) && res.set(item[uniId], 1));
  },
  //首字母大写
  fmt_cf(str, type) {
    if (!type) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    } else if (type === "all") {
      return str.toLowerCase();
    }
  },
};
